module.exports = __webpack_public_path__ + "static/media/thermometer.3948d9cb.svg";